import React from 'react'
import { useTranslation } from 'react-i18next'
import { Combobox } from '@node-space/ui-components'
import useFilterStatus from 'components/FilterBar/hooks/useFilterStatus'
import { PaymentStatus, PaymentType } from 'types/payments'
import { titleCase } from 'utils/utils'

type FilterStatusProps = {
  onPaymentStatusChanged: (value: string) => void
  isChannel: boolean
}

const FilterStatus = ({ onPaymentStatusChanged, isChannel }: FilterStatusProps) => {
  const { t } = useTranslation()

  const { status } = useFilterStatus()

  const paymentStatusOptions = [
    { value: PaymentStatus.ALL, leftText: titleCase(PaymentStatus.ALL) },
    { value: PaymentStatus.PENDING, leftText: titleCase(PaymentStatus.PENDING) },
    { value: PaymentStatus.PROCESSING, leftText: titleCase(PaymentStatus.PROCESSING) },
    { value: PaymentStatus.EXPIRED, leftText: titleCase(PaymentStatus.EXPIRED) },
    { value: PaymentStatus.UNDERPAID, leftText: titleCase(PaymentStatus.UNDERPAID) },
    { value: PaymentStatus.CANCELLED, leftText: titleCase(PaymentStatus.CANCELLED) },
    { value: PaymentStatus.COMPLETE, leftText: titleCase(PaymentStatus.COMPLETE) },
  ]

  const channelPaymentStatusOptions = [
    { value: PaymentStatus.ALL, leftText: titleCase(PaymentStatus.ALL) },
    { value: PaymentStatus.DETECTED, leftText: titleCase(PaymentStatus.DETECTED) },
    { value: PaymentStatus.COMPLETE, leftText: titleCase(PaymentStatus.COMPLETE) },
  ]

  const onStatusChange = (status: PaymentType) => {
    onPaymentStatusChanged(status)
  }

  return (
    <Combobox
      id="status"
      label={t('status')}
      data-testid="filter-status-field"
      defaultValue={status}
      items={isChannel ? channelPaymentStatusOptions : paymentStatusOptions}
      onChange={onStatusChange}
    />
  )
}

export default FilterStatus
